import { API_ENDPOINTS } from "@/configs";
import apiRequest from "@/lib/axios";
import { SupportWidgetConfig, SupportWidgetIdentity } from "@/types";

export const getSupportWidget = async (): Promise<SupportWidgetConfig> =>
  apiRequest({
    method: "GET",
    url: API_ENDPOINTS.SUPPORT_WIDGET.CONFIG,
    errorMessage: "Failed to load the support chat",
  });

export const getSupportWidgetIdentity = async (): Promise<SupportWidgetIdentity> =>
  apiRequest({
    method: "GET",
    url: API_ENDPOINTS.SUPPORT_WIDGET.IDENTITY,
    errorMessage: "Failed to load the support chat identity",
  });
